<template>
  <el-popover
    ref="popover"
    placement="bottom"
    trigger="click"
    transition="el-zoom-in-top"
    popper-class="side-menu-drop"
  >
    <template #reference>
      <div class="drop-wrap cursor-pointer">
        <!--        <div class="drop-img">-->
        <!--                            <el-image class="item-img" :src="user.userInfo.avatar" fit="fill" />-->
        <!--        </div>-->
        <div class="shop-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 32 32"
            aria-labelledby="store"
            preserveAspectRatio="xMidYMid meet"
            role="presentation"
            class="y-icon empty-icon"
          >
            <g>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.64138 6.10345C8.38515 5.3951 9.37289 5 10.4 5H21.6C22.6271 5 23.6149 5.3951 24.3586 6.10345L26.8662 8.49164C27.5698 9.16175 27.9767 10.0836 27.999 11.0527L28 11.1371V11.3027C28 12.8525 27.0598 14.1828 25.7188 14.7542V20C25.7188 21.6569 24.3756 23 22.7188 23H16.7188V25H20.7188V27H10.7188V25H14.7188V23H8.71875C7.0619 23 5.71875 21.6569 5.71875 20L5.71875 14.4555C4.6846 13.7878 4 12.6252 4 11.3027V11.0527C4.02236 10.0836 4.43016 9.16175 5.13377 8.49164L7.64138 6.10345ZM22.7188 21C23.271 21 23.7188 20.5523 23.7188 20V15.0154C22.8467 14.8917 22.0712 14.4681 21.5 13.8523C20.8151 14.5906 19.8365 15.0527 18.75 15.0527C17.6635 15.0527 16.6849 14.5906 16 13.8523C15.3151 14.5906 14.3365 15.0527 13.25 15.0527C12.1635 15.0527 11.1849 14.5906 10.5 13.8523C9.81513 14.5906 8.83653 15.0527 7.75 15.0527L7.71875 15.0526V20C7.71875 20.5523 8.16647 21 8.71875 21H22.7188ZM25.9978 11.0527C25.9993 11.0808 26 11.1089 26 11.1371V11.3027C26 12.2692 25.2165 13.0527 24.25 13.0527C23.2835 13.0527 22.5 12.2692 22.5 11.3027V11.0527H25.9978ZM20.5 11.0527V11.3027C20.5 12.2692 19.7165 13.0527 18.75 13.0527C17.7835 13.0527 17 12.2692 17 11.3027V11.0527H20.5ZM15 11.3027V11.0527H11.5V11.3027C11.5 12.2692 12.2835 13.0527 13.25 13.0527C14.2165 13.0527 15 12.2692 15 11.3027ZM9.5 11.0527H6.00215C6.00072 11.0808 6 11.1089 6 11.1371V11.3027C6 12.2692 6.7835 13.0527 7.75 13.0527C8.7165 13.0527 9.5 12.2692 9.5 11.3027V11.0527ZM22.9793 7.55172L24.5554 9.05273H7.44463L9.02069 7.55172C9.39257 7.19755 9.88645 7 10.4 7H21.6C22.1136 7 22.6074 7.19755 22.9793 7.55172Z"
              ></path>
            </g>
          </svg>
        </div>
        <template v-if="!menuStore.isCollapse">
          <div class="drop-title">
            <el-text truncated class="text">
              {{ storeStore.currentStoreName }}
            </el-text>
          </div>
          <el-icon><ArrowDownBold /></el-icon>
        </template>
      </div>
    </template>

    <template #default>
      <div class="drop-pop">
        <!-- <span class="pop-title">SUAS LOJAS</span> -->
        <!-- <div class="pop-input">
          <el-input v-model="storeValue" placeholder="Please input" />
        </div> -->
        <div class="pop-box">
          <div
            class="pop-box-item"
            :class="
              storeStore.currentStoreId === store.storeCode ? 'active' : ''
            "
            v-for="store in storeStore.stores"
            :key="store.storeCode"
            @click="switchStore(store.storeCode, store)"
          >
            <div class="box-item-title">{{ store.storeName }}</div>
          </div>
        </div>
        <div class="pop-box-footer" @click="addStore">
          <div class="box-item-title">+ &emsp;{{ $t('addastore') }}</div>
        </div>
      </div>
    </template>
  </el-popover>
  <WiioRechargeDialog
    :visible="viewTrackDialog"
    :data="viewTrackDialogData"
    @confirm="() => (viewTrackDialog = false)"
    @cancel="() => (viewTrackDialog = false)"
  />
</template>

<script setup lang="ts">
import { ref, watch, onMounted } from 'vue'
import { useCloned } from '@vueuse/core'
import { MenuStore } from '@/store/modules/menu'
import useStoreStore from '@/store/modules/store'
import useUserStore from '@/store/modules/user'
import { useRouter } from 'vue-router'
import { useJSCore } from 'sm-js-core'
import { getBindStore } from '@/api/settings'
import { checkWiioPaid } from '@/api/coupon'
import platformManager from '@/service/PlatformManager'
import { ElLoading } from 'element-plus'
import WiioRechargeDialog from './component/wiioRechargeDialog.vue'

defineOptions({
  name: 'SideMenuDrop'
})

const $t: any = inject('$t')
const popover = ref(null)
const storeValue = ref(null)
const itemList = ref([
  {
    bgColor: '#57CF79',
    title: 'firstStore'
  }
])
const menuStore = MenuStore()
const storeStore = useStoreStore()
const viewTrackDialog = ref(false)
const viewTrackDialogData = ref({})
// 存儲一份數據用來过滤
let cloneItemList: any = []
onMounted(() => {
  if (!storeStore.currentStoreId) {
    storeStore.getStoresData()
    cloneItemList = useCloned(itemList).cloned.value
  }
})

const updateStoreInfo = (storeCode: any) => {
  if (!storeCode) {
    return
  }
  getBindStore(storeCode)
    .then((res) => {
      if (res.success) {
        useStoreStore().updateCurrentStoreId(
          storeCode,
          res.data.storeName,
          res.data.timeZone
        )
      }
    })
    .catch(() => {})
}

const switchStore = (id: string, store: any) => {
  // storeStore.setCurrentStoreId(id)
  useStoreStore().updateCurrentStoreId(id, store.storeName, store.timeZone)
  popover.value && popover.value.hide()
  updateStoreInfo(id)
  if (router.currentRoute.value.path === '/settings/storebindsettings') {
    router.replace({
      path: '/settings/storebindsettings',
      query: {
        tab: 1,
        type: 'edit'
      }
    })
  }
}

watch(
  () => storeValue.value,
  () => {
    itemList.value = cloneItemList.filter((f: any) =>
      f.title.includes(storeValue.value)
    )
  }
)

const router = useRouter()

const addStore = () => {
  const from = platformManager.getForm()
  if (from !== 'wiio') {
    router.push({
      path: '/settings/storebindsettings',
      query: {
        tab: 1,
        type: 'add'
      }
    })
    return
  }
  // 开启全屏 loading
  const loading = ElLoading.service({
    lock: true,
    background: 'rgba(0, 0, 0, 0.7)'
  })

  checkWiioPaid()
    .then((res: any) => {
      loading.close()
      if (res.data.NyFeePaid === true) {
        // 非NY续费 或者
        router.push({
          path: '/settings/storebindsettings',
          query: {
            tab: 1,
            type: 'add'
          }
        })
      } else {
        const BackUrl = res.data.BackUrl

        if (!useJSCore().base.isEmpty(BackUrl)) {
          viewTrackDialog.value = true
          viewTrackDialogData.value = res.data
        } else {
          ElMessage.error(`${$t('errorMessage')} ,url is empty`)
        }
      }
    })
    .catch(() => {
      loading.close()
    })
}
</script>

<style lang="scss" scoped>
.drop-wrap {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 10px 0 16px;

  .drop-img {
    width: 32px;
    height: 32px;

    .item-img {
      width: 100%;
      height: 100%;
    }
  }

  .shop-icon {
    width: 28px;
    height: 28px;
    border-radius: 30px;
    border: 1px solid var(--el-color-primary);
    display: flex;
    justify-content: center;
    align-items: center;

    svg {
      width: 24px;
      height: 24px;

      path {
        fill: var(--el-color-primary);
      }
    }

    img {
      filter: brightness(0) saturate(100%) invert(27%) sepia(51%)
        saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%);
      color: var(--current-color);
    }
  }

  .drop-title {
    font-weight: 600;
    flex: 1;
    padding: 0 6px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .text {
      font-size: 17px;
    }
  }
}

.pop-title {
  color: #582db4;
  font-size: 12px;
  font-weight: 600;
}

.pop-input {
  margin: 15px 0;
}

.drop-pop {
  max-height: 400px;
  display: flex;
  flex-direction: column;
}
.pop-box {
  flex: 1;
  overflow: auto;
  .pop-box-item {
    display: flex;
    align-items: center;
    padding: 12px;
    color: #56545e;
    font-size: 16px;
    cursor: pointer;
    &.active {
      background-color: var(--el-menu-hover-bg-color);
      color: $primary-color;
    }
    &:hover {
      color: $primary-color;
    }
  }

  .box-item-icon {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    text-align: center;
    line-height: 26px;
    box-sizing: border-box;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    background-color: #ccc;
  }
}

.pop-box-footer {
  height: 45px;
  box-sizing: border-box;
  cursor: pointer;
  border-top: 1px solid #e5e5e5;
  padding: 12px;
  display: flex;
  align-items: center;
  &:hover {
    color: $primary-color;
  }
}
</style>
